import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
/**
 * Displays a registration settlement line
 */
@Component({
  selector: 'ngx-settle-line',
  templateUrl: './settle-line.component.html',
  styleUrls: ['./settle-line.component.scss'],
  imports: [CommonModule]
})
export class SettleLineComponent {
  /**
   * Line title
   */
  @Input()
  title = ''
  /**
   * Count
   */
  @Input()
  count = ''
  /**
   * Displayed in bold?
   */
  @Input()
  bold = false
}
